var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300781,
    y: 22.9043,
    width: 22.5068,
    height: 6.30192,
    transform: "rotate(-90 0.300781 22.9043)",
    fill: "#7163d0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.30273,
    y: 22.9043,
    width: 22.5068,
    height: 2.70082,
    transform: "rotate(-90 9.30273 22.9043)",
    fill: "#7163d0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7051,
    y: 22.9043,
    width: 22.5068,
    height: 2.70082,
    transform: "rotate(-90 14.7051 22.9043)",
    fill: "#7163d0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1074,
    y: 22.9043,
    width: 22.5068,
    height: 2.70082,
    transform: "rotate(-90 20.1074 22.9043)",
    fill: "#7163d0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.ba5c5a58.svg";
export { ForwardRef as ReactComponent };